import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class AppServicesIndexRoute extends Route {
  @service('router') declare routerService: RouterService;

  beforeModel() {
    this.routerService.transitionTo('app.services.walden-green');
  }
}
